import {singleton} from "tsyringe";
import {getProperty} from "dot-prop";

declare var configuration: Record<string|number, any>;

@singleton()
export class ConfigurationManager {

  public get<T>(path: string, defaultValue?: T): T {
    return getProperty(configuration, path, defaultValue);
  }
}